import type { RootState } from '@/_store/store';

export const selectUser = (state: RootState) => state.auth.payload;
export const selectToken = (state: RootState) => state.auth.token;
